export enum MaintainRuleSetTabs {
    Basics = 1,
    ProductDocumentApplications,
    IgnoreRuleOrEntireRuleSets,
    DeletedRules
}
